import { PendingTaskStatus } from './pending-tasks';

export interface TGetAdminActivityLogsRequest extends Record<string, any> {
    adminEmail?: string;
    nexId?: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
    actionType?: ActionType;
}

export interface TGetAdminActivityLogsResponse {
    data: TAdminActivityLog[];
    count: number;
    currentPage: number;
    lastPage: number;
}

export interface TGetAdminActivityLogDetailRequest {
    id: string;
}

export interface TGetAdminActivityLogDetailResponse {
    id: string;
    userId: string | null;
    nexId: string | null;
    pendingTaskId: string | null;
    pendingTaskStatus: PendingTaskStatus;
    adminEmail: string;
    actionType: ActionType;
    actionLevel: ActionLevel;
    createdAt: string;
    details: IAdminActivityLogDetailItem[];
}

export interface TAdminActivityLog {
    id: string;
    adminEmail: string;
    actionType: ActionType;
    actionLevel: ActionLevel;
    pendingTaskStatus: PendingTaskStatus | null;
    relatedUserNexId: string | null;
    createdAt: string;
}

export enum AdminActivityLogDetailType {
    CASH_WITHDRAWAL_TRANSACTION_ID = 'CASH_WITHDRAWAL_TRANSACTION_ID',
    CASH_WITHDRAWAL_TRANSACTION_AMOUNT = 'CASH_WITHDRAWAL_TRANSACTION_AMOUNT',
    REJECT_KYC_REASON = 'REJECT_KYC_REASON',
    CLOSE_USER_REASON = 'CLOSE_USER_REASON',
    REJECT_TASK_REASON = 'REJECT_TASK_REASON',
}

export interface IAdminActivityLogDetailItem {
    name: AdminActivityLogDetailType;
    value: string | number;
}

export enum ActionType {
    ALL = 'ALL',
    VIEW_TRANSACTIONS_LIST = 'VIEW_TRANSACTIONS_LIST',
    VIEW_USERS_LIST = 'VIEW_USERS_LIST',
    VIEW_USER_DETAIL = 'VIEW_USER_DETAIL',
    VIEW_USER_EKYC_DETAIL = 'VIEW_USER_EKYC_DETAIL',
    VIEW_USER_ACTIVITY_LOG = 'VIEW_USER_ACTIVITY_LOG',
    RESET_PIN = 'RESET_PIN',
    REJECT_EKYC = 'REJECT_EKYC',
    APPROVE_EKYC = 'APPROVE_EKYC',
    UNBLOCK_USER = 'UNBLOCK_USER',
    CLOSE_USER = 'CLOSE_USER',
    ACTIVATE_USER = 'ACTIVATE_USER',
    SUSPEND_USER = 'SUSPEND_USER',
    CASH_WITHDRAWAL_TRANSACTION = 'CASH_WITHDRAWAL_TRANSACTION',
}

export enum ActionLevel {
    VIEW = 'VIEW',
    INITIATE = 'INITIATE',
    APPROVE = 'APPROVE',
}
